<div class="bg-blue-2 d-flex al-center sp-between p-4">
  <div>
    <div>
      <span class="text-white fw-extrabold fs-4">Filtros</span>
    </div>
    <div>
      <span class="text-white fs-6 fw-regular">Filtra a tus clientes mediante las siguientes opciones.</span>
    </div>
  </div>
  <div>
    <img src="assets/svg/Icon_close.svg" mat-dialog-close alt="">
  </div>
</div>
<mat-dialog-content class="px-5 pt-4 d-flex flex-column content-form">
  <div class="mb-3">
    <span class="fs-6 fw-semibold">País</span>
  </div>
  <div class="content-countries">
    <div class="row">
      <div class="col-md-6 mb-2" *ngFor="let country of countries">
        <label nz-checkbox class="fs-regular fs-6" [(ngModel)]="country.checked">{{country.descripcion}}</label>
      </div>
    </div>
  </div>
  <br>
  <div class="mb-3">
    <span class="fs-6 fw-semibold">Estado</span>
  </div>
  <div class="d-flex gap flex-wrap">
    <div *ngFor="let state of states" [ngClass]="state.selected ? [state.class, 'enabled']:[state.class, 'disabled']"
      class="content-state rounded d-flex al-center sp-center pointer animated"
      (click)="state.selected = !state.selected">
      <span class="text-white fw-regular fs-6">{{state.label}}</span>
    </div>
  </div>
  <br>
  <ng-container *ngIf="rol == 1">
    <div class="mb-3">
      <span class="fs-6 fw-semibold">Rango</span>
    </div>
    <div class="d-flex gap flex-wrap">
      <div *ngFor="let range of ranges" [ngClass]="range.selected ? 'bg-blue-2':'border'"
        class="content-state rounded d-flex al-center sp-center pointer animated"
        (click)="range.selected = !range.selected">
        <span class="fw-regular fs-6" [ngClass]="range.selected ? 'text-white':''">{{range.descripcion}}</span>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="rol == 3">
    <div class="mb-3">
      <span class="fs-6 fw-semibold">Cantidad de productos</span>
    </div>
    <div class="content-slider">
      <nz-slider [(ngModel)]="products"></nz-slider>
    </div>
    <div class="content-detail-products border rounded px-3">
      <div>
        <span class="fs-7 text-secondary fw-regular">Mayor o igual a</span>
      </div>
      <div>
        <span class="fs-7 fw-semibold">{{products}} productos</span>
      </div>
    </div>
  </ng-container>
  <hr>
</mat-dialog-content>
<div class="p-4 text-end content-action">
  <mat-dialog-actions align="end">
    <button mat-flat-button class="bg-blue-2" (click)="sendFilters();">
      <span class="fw-bold fs-5 text-white me-3">Filtrar</span>
      <img src="assets/svg/Icon_arrow_right_white.svg" alt="">
    </button>
  </mat-dialog-actions>
</div>